<template>
    <b-container fluid class="px-md-5">
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">{{ $route.query.pending === 'true' ? 'Clientes Pendientes de Aprobación' : 'Clientes' }}</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay clientes que coincidan con la búsqueda"
                    empty-text="No hay clientes para mostrar"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(actions)="row">
                        <b-button variant="info" size="sm" title="Editar Usuario" @click="getData(row.item.id)" v-b-modal.user>
                            <i class="material-icons">edit</i>
                        </b-button>
                        <b-button variant="default" size="sm" title="Actualizar Tipo de Usuario" @click="getData(row.item.id)" v-b-modal.role>
                            <i class="material-icons">elevator</i>
                        </b-button>
                        <b-button :variant="row.item.status === 203 ? 'success' : 'danger'" size="sm">
                            <i class="material-icons">{{ row.item.status === 203 ? 'lock' : 'lock_open' }}</i>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>
                </b-table>

                <!-- Modal Photo Viewer -->
                <b-modal
                    id="photo"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    :title="photo_text"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <img :src="'/'+(photo ? photo : 'img/no-image.png')" :title="form.name + ' ' + form.lname" :alt="form.name + ' ' + form.lname" width="100%"/>
                </b-modal>

                <!-- Modal Update User Details -->
                <b-modal
                    id="user"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    title="Validar Usuario"
                    tabindex="-1"
                    role="dialog"
                    size="xl"
                    aria-hidden="true">
                    <div class="text-center">
                        <div class="figure-profile shadow my-4">
                            <figure @click="zoomImg(1)" v-b-modal.photo>
                                <img :src="'/'+(form.photo ? form.photo : 'img/user-default.png')" :alt="form.name + ' ' + form.lname"
                                     :title="form.name + ' ' + form.lname">
                            </figure>
                            <b-button variant="danger" class="text-white floating-btn" @click="deleteImg(1)" v-if="form.status === 202">
                                <i class="material-icons">delete</i>
                            </b-button>
                        </div>
                    </div>
                    <b-form id="formUser" @submit.stop.prevent="updateUser(form.id)">
                        <h6 class="subtitle text-center">Información Básica</h6>
                        <b-row align-h="center">
                            <b-col cols="12" md="4" align-self="start">
                                <b-form-group :class="'float-label' + (form.name !== '' ? ' active' : '')">
                                    <b-form-input
                                        name="name"
                                        type="text"
                                        v-model="form.name"
                                        v-validate="( form.status === 203 ? 'required:true|' : '' ) + 'alpha_spaces|min:3|max:20'"
                                        :state="validateState('name')"
                                        :data-vv-as="(labels.name).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="name-live-feedback"
                                    ></b-form-input>
                                    <label class="form-control-label">{{ labels.name }}:</label>
                                    <b-form-invalid-feedback id="name-live-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="3" align-self="start">
                                <b-form-group :class="'float-label' + (form.lname !== '' ? ' active' : '')">
                                    <b-form-input
                                        name="lname"
                                        type="text"
                                        v-model="form.lname"
                                        v-validate="( form.status === 203 ? 'required:true|' : '' ) + 'alpha_spaces|min:3|max:20'"
                                        :state="validateState('lname')"
                                        :data-vv-as="(labels.lname).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="lname-live-feedback"
                                    ></b-form-input>
                                    <label class="form-control-label">{{ labels.lname }}:</label>
                                    <b-form-invalid-feedback id="lname-live-feedback">{{ veeErrors.first('lname') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="3" align-self="start">
                                <b-form-group :class="'float-label' + (form.mname !== '' ? ' active' : '')">
                                    <b-form-input
                                        name="mname"
                                        type="text"
                                        v-model="form.mname"
                                        v-validate="'alpha_spaces|max:19'"
                                        :state="validateState('mname')"
                                        :data-vv-as="(labels.mname).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="mname-live-feedback"
                                    ></b-form-input>
                                    <label class="form-control-label">{{ labels.mname }}:</label>
                                    <b-form-invalid-feedback id="mname-live-feedback">{{ veeErrors.first('mname') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :class="'float-label' + (form.email !== '' ? ' active' : '')">
                                    <b-form-input
                                        name="email"
                                        type="text"
                                        v-model="form.email"
                                        v-validate="( form.status === 203 ? 'required:true' : '' )"
                                        :state="validateState('email')"
                                        :data-vv-as="(labels.email).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="email-live-feedback"
                                    ></b-form-input>
                                    <label class="form-control-label">{{ labels.email }}:</label>
                                    <b-form-invalid-feedback id="email-live-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :class="'float-label' + (form.mobile !== '' ? ' active' : '')">
                                    <b-form-input
                                        name="mobile"
                                        type="tel"
                                        v-model="form.mobile"
                                        v-validate="( form.status === 203 ? 'required:true' : '' )"
                                        :state="validateState('mobile')"
                                        :data-vv-as="(labels.mobile).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="mobile-live-feedback"
                                    ></b-form-input>
                                    <label class="form-control-label">{{ labels.mobile }}:</label>
                                    <b-form-invalid-feedback id="mobile-live-feedback">{{ veeErrors.first('mobile') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :class="'float-label' + (form.birthday !== '' ? ' active' : '')">
                                    <b-form-datepicker
                                        name="birthday"
                                        v-model="form.birthday"
                                        v-bind="labels['es'] || {}"
                                        v-validate="( form.status === 203 ? 'required:true|' : '' ) + 'date_format:yyyy-MM-dd'"
                                        :state="validateState('birthday')"
                                        :data-vv-as="(labels.birthday).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="birthday-live-feedback"
                                        locale="es"
                                        :min="minDate"
                                        :max="maxDate"
                                        hide-header
                                        no-flip
                                        class="text-left"
                                    ></b-form-datepicker>
                                    <label class="form-control-label">{{ labels.birthday }}:</label>
                                    <b-form-invalid-feedback id="birthday-live-feedback">{{ veeErrors.first('birthday') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :class="'float-label' + (form.profession !== '' ? ' active' : '')">
                                    <b-form-select
                                        name="profession"
                                        :options="professions"
                                        :value="form.profession"
                                        v-model="form.profession"
                                        v-validate="( form.status === 203 ? 'required:true' : '' )"
                                        :state="validateState('profession')"
                                        :data-vv-as="(labels.profession).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="profession-live-feedback"
                                        class="form-control"
                                        value-field="name"
                                        text-field="name"
                                    ></b-form-select>
                                    <label class="form-control-label">{{ labels.profession }}:</label>
                                    <b-form-invalid-feedback id="profession-live-feedback">{{ veeErrors.first('profession') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :class="'float-label' + (form.pep !== '' ? ' active' : '')">
                                    <b-form-select
                                        name="pep"
                                        :options="yes_no"
                                        :value="form.pep"
                                        v-model="form.pep"
                                        v-validate="( form.status === 203 ? 'required:true' : '' )"
                                        :state="validateState('pep')"
                                        :data-vv-as="(labels.pep).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="pep-live-feedback"
                                        class="form-control"
                                        value-field="code"
                                        text-field="text"
                                    ></b-form-select>
                                    <label class="form-control-label">{{ labels.pep }}:</label>
                                    <b-form-invalid-feedback id="pep-live-feedback">{{ veeErrors.first('pep') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row align-h="center">
                            <b-col cols="12" md="10" align-self="center">
                                <hr>
                            </b-col>
                        </b-row>
                        <h6 class="subtitle text-center mt-0">Identificación Personal</h6>
                        <b-row align-h="center">
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :class="'float-label' + (form.td !== '' ? ' active' : '')">
                                    <b-form-select
                                        name="td"
                                        :options="td"
                                        :value="form.td"
                                        v-model="form.td"
                                        v-validate="( form.status === 203 ? 'required:true' : '' )"
                                        :state="validateState('td')"
                                        :data-vv-as="(labels.td).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="td-live-feedback"
                                        class="form-control"
                                        value-field="code"
                                        text-field="name"
                                    ></b-form-select>
                                    <label class="form-control-label">{{ labels.td }}:</label>
                                    <b-form-invalid-feedback id="td-live-feedback">{{ veeErrors.first('td') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start" v-if="form.td === 'RUT'">
                                <b-form-group :class="'float-label' + (form.rut !== '' && form.rut !== null ? ' active' : '')">
                                    <b-form-input
                                        name="rut"
                                        type="text"
                                        v-model="form.rut"
                                        v-validate="( form.status === 203 ? 'required:true' : '' )"
                                        :state="validateState('rut')"
                                        :data-vv-as="(labels.rut).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="rut-live-feedback"
                                        v-mask="mask"
                                    ></b-form-input>
                                    <label class="form-control-label">{{ labels.rut }}:</label>
                                    <b-form-invalid-feedback id="rut-live-feedback">{{ veeErrors.first('rut') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start" v-else>
                                <b-form-group :class="'float-label' + (form.nd !== '' ? ' active' : '')">
                                    <b-form-input
                                        name="nd"
                                        :type="form.td === 'PS' ? 'text' : 'number'"
                                        v-model="form.nd"
                                        v-validate="( form.status === 203 ? 'required:true' : '' )"
                                        :state="validateState('nd')"
                                        :data-vv-as="(labels.nd).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="nd-live-feedback"
                                    ></b-form-input>
                                    <label class="form-control-label">{{ labels.nd }}:</label>
                                    <b-form-invalid-feedback id="nd-live-feedback">{{ veeErrors.first('nd') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :class="'float-label' + (form.issuedBy !== '' ? ' active' : '')">
                                    <b-form-select
                                        name="sender_issuedBy"
                                        :options="countries_list"
                                        :value="form.issuedBy"
                                        v-model="form.issuedBy"
                                        v-validate="( form.status === 203 ? 'required:true' : '' )"
                                        :state="validateState('issuedBy')"
                                        :data-vv-as="(labels.issuedBy).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="issuedBy-live-feedback"
                                        class="form-control"
                                        value-field="iso2"
                                        text-field="name"
                                    ></b-form-select>
                                    <label class="form-control-label">{{ labels.issuedBy }}:</label>
                                    <b-form-invalid-feedback id="issuedBy-live-feedback">{{ veeErrors.first('issuedBy') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :class="'float-label' + (form.expiration !== '' ? ' active' : '')">
                                    <b-form-datepicker
                                        name="expiration"
                                        v-model="form.expiration"
                                        v-bind="labels['es'] || {}"
                                        v-validate="( form.status === 203 ? 'required:true|' : '' ) + 'date_format:yyyy-MM-dd'"
                                        :state="validateState('expiration')"
                                        :data-vv-as="(labels.expiration).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="expiration-live-feedback"
                                        locale="es"
                                        :min="minDateExp"
                                        hide-header
                                        no-flip
                                        class="text-left"
                                    ></b-form-datepicker>
                                    <label class="form-control-label">{{ labels.expiration }}:</label>
                                    <b-form-invalid-feedback id="expiration-live-feedback">{{ veeErrors.first('expiration') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row align-h="center">
                            <b-col cols="12" md="10" align-self="center">
                                <hr>
                            </b-col>
                        </b-row>
                        <h6 class="subtitle text-center mt-0">Ubicación Actual</h6>
                        <b-row align-h="center">
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :class="'float-label' + (form.address !== '' ? ' active' : '')">
                                    <b-form-input
                                        name="address"
                                        type="text"
                                        v-model="form.address"
                                        v-validate="( form.status === 203 ? 'required:true' : '' )"
                                        :state="validateState('address')"
                                        :data-vv-as="(labels.address).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="address-live-feedback"
                                    ></b-form-input>
                                    <label class="form-control-label">{{ labels.address }}:</label>
                                    <b-form-invalid-feedback id="address-live-feedback">{{ veeErrors.first('address') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :class="'float-label' + (form.district !== '' ? ' active' : '')">
                                    <b-form-input
                                        name="district"
                                        type="text"
                                        v-model="form.district"
                                        v-validate="( form.status === 203 ? 'required:true' : '' )"
                                        :state="validateState('district')"
                                        :data-vv-as="(labels.district).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="district-live-feedback"
                                    ></b-form-input>
                                    <label class="form-control-label">{{ labels.district }}:</label>
                                    <b-form-invalid-feedback id="district-live-feedback">{{ veeErrors.first('district') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :class="'float-label' + (form.zipcode !== '' ? ' active' : '')">
                                    <b-form-input
                                        name="zipcode"
                                        v-model="form.zipcode"
                                        type="text"
                                        v-validate="( form.status === 203 ? 'required:true' : '' )"
                                        :state="validateState('zipcode')"
                                        :data-vv-as="(labels.zipcode).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="zipcode-live-feedback"
                                    ></b-form-input>
                                    <label class="form-control-label">{{ labels.zipcode }}:</label>
                                    <b-form-invalid-feedback id="zipcode-live-feedback">{{ veeErrors.first('zipcode') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :class="'float-label' + (form.city !== '' ? ' active' : '')">
                                    <b-form-input
                                        name="city"
                                        type="text"
                                        v-model="form.city"
                                        v-validate="( form.status === 203 ? 'required:true' : '' )"
                                        :state="validateState('city')"
                                        :data-vv-as="(labels.city).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="city-live-feedback"
                                    ></b-form-input>
                                    <label class="form-control-label">{{ labels.city }}:</label>
                                    <b-form-invalid-feedback id="city-live-feedback">{{ veeErrors.first('city') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :class="'float-label' + (form.state !== '' ? ' active' : '')">
                                    <b-form-input
                                        name="state"
                                        type="text"
                                        v-model="form.state"
                                        v-validate="( form.status === 203 ? 'required:true' : '' )"
                                        :state="validateState('state')"
                                        :data-vv-as="(labels.state).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="state-live-feedback"
                                    ></b-form-input>
                                    <label class="form-control-label">{{ labels.state }}:</label>
                                    <b-form-invalid-feedback id="state-live-feedback">{{ veeErrors.first('state') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row align-h="center">
                            <b-col cols="12" md="10" align-self="center">
                                <hr>
                            </b-col>
                        </b-row>
                        <h6 class="subtitle text-center mt-0">Documento</h6>
                        <b-row align-h="center">
                            <b-col cols="12" md="5" align-self="start">
                                <div class="text-center">
                                    <div class="document-profile shadow my-4">
                                        <figure @click="zoomImg(2)" v-b-modal.photo>
                                            <img :src="'/'+(form.front ? form.front : 'img/doc_front.png')" alt="Documento Frontal" title="Documento Frontal">
                                        </figure>
                                        <b-button variant="danger" class="text-white floating-btn" @click="deleteImg(2)" v-if="form.status === 202">
                                            <i class="material-icons">delete</i>
                                        </b-button>
                                    </div>
                                </div>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <div class="text-center">
                                    <div class="document-profile shadow my-4">
                                        <figure @click="zoomImg(3)" v-b-modal.photo>
                                            <img :src="'/'+(form.post ? form.post : 'img/doc_post.png')" alt="Documento Posterior" title="Documento Posterior">
                                        </figure>
                                        <b-button variant="danger" class="text-white floating-btn" @click="deleteImg(3)" v-if="form.status === 202">
                                            <i class="material-icons">delete</i>
                                        </b-button>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row align-h="center">
                            <b-col cols="12" md="10" align-self="center">
                                <hr>
                            </b-col>
                        </b-row>
                        <h6 class="subtitle text-center mt-0">Estado interno</h6>
                        <b-row align-h="center">
                            <b-col cols="12" md="10" align-self="start">
                                <b-form-group :label="labels.status+':'">
                                    <b-form-radio-group
                                        v-model="form.status"
                                        :options="validations"
                                        v-validate="'required:true'"
                                        :state="validateState('status')"
                                        :data-vv-as="(labels.status).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="status-live-feedback"
                                        :button-variant="'outline-' + color"
                                        class="btn-block align-baseline"
                                        name="status"
                                        value-field="code"
                                        text-field="title"
                                        :stacked="$isMobile()"
                                        buttons
                                    ></b-form-radio-group>
                                    <b-form-invalid-feedback id="status-live-feedback">{{ veeErrors.first('status') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" class="pb-3" align-self="start">
                                <b-form-group :label="labels.details+':'">
                                    <b-form-textarea
                                        id="details"
                                        name="details"
                                        v-model="form.details"
                                        v-validate="'max:255'"
                                        :state="validateState('details') || (form.details ? form.details.length <= 255 : '')"
                                        aria-describedby="details-live-feedback"
                                        :data-vv-as="(labels.details).toLowerCase()"
                                        placeholder="Ingrese la respuesta del proceso de aprobación..."
                                        rows="3"
                                        no-resize
                                        :disabled="loading"
                                        class="rounded"
                                    ></b-form-textarea>
                                    <b-form-invalid-feedback id="details-live-feedback">{{ veeErrors.first('details') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="10" align-self="start" class="my-4">
                                <b-button type="submit" variant="default" size="lg" pill class="shadow align-middle px-5" form="formUser" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="upload" aria-hidden="true" class="align-middle" v-else></b-icon>
                                    &nbsp;&nbsp;<span>{{ loading ? 'Actualizando...' : 'Actualizar' }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-modal>

                <!-- Modal Update User Role -->
                <b-modal
                    id="role"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    title="Actualizar Tipo de Usuario"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <b-form id="formRole" @submit.stop.prevent="updateRole(id)">
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="9" align-self="start">
                                <b-form-group :label="labels.role+':'">
                                    <b-form-select
                                        name="role"
                                        :options="roles"
                                        :value="form.role"
                                        v-model="form.role"
                                        class="form-control select-center"
                                        v-validate=""
                                        :state="validateState('role')"
                                        :data-vv-as="(labels.role).toLowerCase()"
                                        :disabled="loading"
                                        aria-describedby="role-live-feedback"
                                        value-field="code"
                                        text-field="name"
                                    ></b-form-select>
                                    <b-form-invalid-feedback id="role-live-feedback">{{
                                            veeErrors.first('role')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="10" align-self="start" class="my-4">
                                <b-button type="submit" variant="default" size="lg" pill class="shadow align-middle px-5" form="formRole" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="upload" aria-hidden="true" class="align-middle" v-else></b-icon>
                                    &nbsp;&nbsp;<span>{{ loading ? 'Actualizando...' : 'Actualizar' }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "Customers",
    data: () => ({
        isBusy: true,
        search: '',
        fields: [
            { key: 'id', label: 'ID', sortable: true },
            { key: 'rname', label: 'Nombre', sortable: true },
            { key: 'email', label: 'Email', sortable: true },
            { key: 'country_text', label: 'País', sortable: true },
            { key: 'status_text', label: 'Estado', sortable: true },
            { key: 'registered', label: 'Registrado', sortable: true },
            { key: 'actions', label: 'Acción', sortable: false }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 50,
        pageOptions: [50, 100, 250, { value: -1, text: "Todos" }],
        id: 0,
        labels: {
            role: 'Tipo de Usuario',
            name: 'Nombres',
            lname: 'Primer Apellido',
            mname: 'Segundo Apellido',
            email: 'Correo Electrónico',
            mobile: 'Teléfono',
            birthday: 'Fecha de Nacimiento',
            profession: 'Profesión',
            pep: '¿Eres Persona Expuesta Políticamente?',

            td: 'Tipo de Documento',
            nd: 'Número de Documento',
            rut: 'RUT',
            issuedBy: 'País de emisión',
            expiration: 'Fecha de Vencimiento',
            noExp: 'Sin Fecha de Vencimiento',

            address: 'Dirección',
            district: 'Comuna/Barrio',
            zipcode: 'Código Postal',
            city: 'Ciudad',
            state: 'Región/Estado/Departamento',

            photo: 'Foto',
            front: 'Frontal',
            post: 'Posterior',

            es: {
                labelPrevDecade: 'Década Anterior',
                labelPrevYear: 'Año Anterior',
                labelPrevMonth: 'Mes Anterior',
                labelCurrentMonth: 'Mes Actual',
                labelNextMonth: 'Próximo Mes',
                labelNextYear: 'Próximo Año',
                labelNextDecade: 'Próxima Década',
                labelToday: 'Hoy',
                labelSelected: 'Fecha Seleccionada',
                labelNoDateSelected: 'Sin fecha seleccionada',
                labelCalendar: 'Calendario',
                labelNav: 'Navegar por el calendario',
                labelHelp: 'Use las teclas de flecha para navegar por el calendario'
            },
            status: 'Validación',
            details: 'Respuesta'
        },
        form: {
            role: 'Customer',
            name: '',
            lname: '',
            mname: '',
            email: '',
            mobile: '',
            birthday: undefined,
            profession: '',
            pep: 0,

            td: '',
            nd: '',
            rut: null,
            issuedBy: '',
            expiration: undefined,

            address: '',
            district: '',
            zipcode: '',
            city: '',
            state: '',
            country: 'CL',

            photo: null,
            front: null,
            post: null,

            status: 201,
            details: null
        },
        roles: [
            { code: 'Customer', name: 'Cliente' },
            { code: 'Cashier', name: 'Cajero (Agente)' },
            { code: 'Partner', name: 'Gerente (Agente)' },
            { code: 'Supervisor', name: 'Supervisor (Agente)' },
            { code: 'Administrator', name: 'Administrador' }
        ],
        minDate: undefined,
        maxDate: undefined,
        td: [
            { code: 'RUT', name: 'RUT' },
            { code: 'DNI', name: 'Documento Nacional de Identidad' },
            { code: 'CI', name: 'Cédula de Identidad' },
            { code: 'CE', name: 'Cédula de Extranjeria' },
            { code: 'PS', name: 'Pasaporte' }
        ],
        professions: [
            { name: 'Ingeniero/a' },
            { name: 'Estudiante' },
            { name: 'Comerciante' },
            { name: 'Empresario/a' },
            { name: 'Abogado/a' },
            { name: 'Administrador/a' },
            { name: 'Médico/a' },
            { name: 'Arquitecto/a' },
            { name: 'Economista' },
            { name: 'Profesor/a' },
            { name: 'Programador/a' },
            { name: 'Amo/a de Casa' },
            { name: 'Artísta ó Artesano/a' },
            { name: 'Rentista de Capital' },
            { name: 'Policía ó Militar' },
            { name: 'Agricultor/a, Ganadero/a ó Pescador/a' },
            { name: 'Técnico/a' },
            { name: 'Otra' }
        ],
        yes_no: [
            { code: 0, text: 'No' },
            { code: 1, text: 'Si' }
        ],
        countries_list: [],
        minDateExp: undefined,
        validations: [],
        loading: false,
        mask: '##.###.###-N',
        photo_text: '',
        photo: undefined,
        color: 'primary'
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'customerpage');
        this.totalRows = this.items.length;
        this.getIni();
        this.getDate();
    },
    watch: {
        '$route.query.pending'() {
            // Recargar cuando cambie el query parameter
            this.isBusy = true;
            this.getIni();
        },
        'form.td'() {
            if (this.form.td !== 'RUT') {
                this.form.rut = null;
            }
        },
        'form.nd'() {
            if (this.form.nd) {
                this.form.nd = (this.form.nd).toUpperCase();
            }
        },
        'form.rut'() {
            if (this.form.rut) {
                this.form.rut = (this.form.rut).toUpperCase();
            }
        },
        'form.status'() {
            this.color = 'primary';
            if (this.form.status === 202) {
                this.color = 'info';
            } else if (this.form.status === 203) {
                this.color = 'success';
            } else if (this.form.status === 204) {
                this.color = 'danger';
            }
        }
    },
    methods: {
        getIni() {
            // Detectar si viene el query parameter pending
            const pending = this.$route.query.pending === 'true';
            const url = pending ? '/api/users/customers?pending=true' : '/api/users/customers';
            
            axios.get(url).then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.items;
                    this.totalRows = this.items.length;
                    this.validations = res.data.validations;
                    this.countries_list = res.data.countries;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
        },
        getData(id) {
            this.id = id;
            this.form = {};
            if (id) {
                const items = this.items;

                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        this.form = items[i];
                    }
                }
            }
        },
        getDate() {
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 100 años menos
            const minDate = new Date(today)
            minDate.setFullYear(minDate.getFullYear() - 100)
            // 18 años menos
            const maxDate = new Date(today)
            maxDate.setFullYear(maxDate.getFullYear() - 18)

            this.minDate = minDate;
            this.maxDate = maxDate;
            this.minDateExp = today;
        },
        zoomImg(v) {
            this.photo = undefined;
            this.photo_text = '';
            if (v === 1) {
                this.photo = this.form.photo;
                this.photo_text = 'Photo de Perfil';
            } else if (v === 2) {
                this.photo = this.form.front;
                this.photo_text = 'Documento Frontal';
            } else if (v === 3) {
                this.photo = this.form.post;
                this.photo_text = 'Documento Posterior';
            }
        },
        deleteImg(v) {
            this.zoomImg(v);
            this.$swal({
                title: '¿Estas seguro de eliminar esta imagen?',
                text: this.photo_text,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar',
                confirmButtonColor: '#28a745',
                cancelButtonText: 'En otro momento',
                cancelButtonColor: '#dc3545',
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    let formData = new FormData();

                    formData.append('img', v);
                    axios.post('/api/users/' + id + '/img/delete', formData).then((res) => {
                        this.$root.$bvToast.toast(res.data.msg, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: res.data.status,
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                        if (res.data.status === 'success') {
                            if (v === 1) {
                                this.form.photo = null
                            } else if (v === 2) {
                                this.form.front = null
                            } else if (v === 3) {
                                this.form.post = null
                            }
                            this.zoomImg();
                        }
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    });
                }
            });
        },
        updateUser(id) {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;

                axios.post('/api/users/'+id+'/update', this.form).then(res => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    this.$validator.reset();
                    this.getIni();
                    this.getData();
                    this.$bvModal.hide('user');
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        updateRole(id) {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;
                axios.post('/api/users/' + id + '/update/role', this.form).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.getIni();
                        this.$bvModal.hide('role');
                        this.getData();
                        this.$validator.reset();
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        }
    }
}
</script>

<style scoped>

</style>
